module.exports = __webpack_public_path__ + "img/kyano-order-logo-dark.8139801b.svg";